export default __webpack_public_path__ + "static/media/CTAImagePro.cb64c2a6.jpg";